import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
    AssetCategory,
    CommunityAssetImageField,
} from "@features/uploadAsset";

import { Text } from "@fragments";

export default function Asset({ configRef, communityId, onUploadingChange }) {
    const { t } = useTranslation("groupModals");
    const [photo, setPhoto] = useState(configRef.current.photo || null);

    function handleChange(url) {
        configRef.current.photo = url;
        setPhoto(url);
    }

    return (
        <div className="banner-add mt-2">
            <Text.span value={t("common:fields.image")} />

            <CommunityAssetImageField
                communityId={communityId}
                category={AssetCategory.GROUP_POST}
                value={photo}
                onChange={handleChange}
                onUploadingChange={onUploadingChange}
                aspectRatio={1}
                size={120}
                imageMaxWidth={1080}
                title={t("publishPost.asset.resizeTitle")}
                displayTitle={false}
            />
        </div>
    );
}
